/**
 * React Query hook for notification settings
 */

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiFetch } from '../lib/api';

export interface NotificationSettings {
  email_enabled: boolean;
  push_enabled: boolean;
  email_digest_frequency: 'daily' | 'weekly' | 'never';
  email_digest_hour: number;
  email_timezone: string;
  notify_new_follower: boolean;
  notify_recommendation: boolean;
  notify_list_shared: boolean;
  notify_milestone: boolean;
}

/**
 * Get user's notification settings
 * Inherits global staleTime (60s) and refetchOnMount (false).
 * Freshness driven by mutation invalidation + refetchOnWindowFocus.
 */
export function useNotificationSettingsQuery() {
  const { user, session } = useAuth();
  const token = session?.access_token;

  return useQuery({
    queryKey: ['notification-settings', user?.id],
    enabled: !!user && !!token,
    queryFn: async ({ signal }) => {
      return apiFetch<NotificationSettings>('/user/notification-settings', { token, signal });
    },
    refetchOnWindowFocus: true,
  });
}
